module.exports = __webpack_public_path__ + "static/media/Zoe1.e8515765.png";